module.exports = __webpack_public_path__ + "img/exam (3).e282b908.png";